/**
 * THE CLEANER'S VIEW OF ONE VISIT: the window and the day, the button to the job sheet, and who is
 * on it with her. It draws the answer the server gives a cleaner, and nothing wider.
 */
import { VISIT_KIND_LABELS } from '@fk/shared';
import type { CleanerVisitDetail, Me } from '../../api.ts';
import { Card, Detail, Pill, ScreenTitle } from '../../components/AppShell.tsx';
import { VisitStatusPill } from '../../components/StatusPills.tsx';
import { crewNames } from '../../components/VisitBits.tsx';
import { formatWindow, longDay } from '../../format.ts';
import { SheetButton, VisitFacts } from './VisitFacts.tsx';
import { PAIR } from './shared.ts';

export function CleanerView({ me, detail }: { me: Me; detail: CleanerVisitDetail }) {
  const { visit, cleaners } = detail;
  const others = crewNames(cleaners.filter((cleaner) => cleaner.cleanerId !== me.cleanerId));
  return (
    <div>
      <ScreenTitle
        title={formatWindow(visit.windowStart, visit.windowEnd) ?? 'No arrival window set'}
        subtitle={longDay(visit.scheduledDate)}
      />
      <div className="mb-4 flex flex-wrap gap-2">
        <VisitStatusPill status={visit.status} />
        <Pill>{VISIT_KIND_LABELS[visit.kind]}</Pill>
      </div>
      <SheetButton visitId={visit.id} />
      <Card className="mb-4">
        <dl className={PAIR}>
          <VisitFacts visit={visit} />
          <Detail label="Working with" value={others ?? 'Just you on this one.'} />
        </dl>
      </Card>
    </div>
  );
}
